import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Icon } from '../Icon';

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: "12.3333",
  cy: "8.33333",
  r: "6.58333",
  stroke: "currentColor",
  strokeWidth: "1.5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 23C22 19.7408 17.5228 15.6667 12 15.6667C6.47715 15.6667 2 18.9259 2 23",
  stroke: "currentColor",
  strokeWidth: "1.5"
});

export var UserIcon = function UserIcon(rest) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, rest), _ref, _ref2);
};